import { render, staticRenderFns } from "./AssignSoundConfirmPopup.vue?vue&type=template&id=57ce3b22&scoped=true"
import script from "./AssignSoundConfirmPopup.vue?vue&type=script&lang=ts"
export * from "./AssignSoundConfirmPopup.vue?vue&type=script&lang=ts"
import style0 from "./AssignSoundConfirmPopup.vue?vue&type=style&index=0&id=57ce3b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ce3b22",
  null
  
)

export default component.exports